<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        ユーザー(教室)情報設定
      </template>

      <template v-slot:content v-if="branch">

        <v-form
          ref="classroom-form"
          :value="classroomValid"
          lazy-validation
        >
          <v-row class="mx-3">
            <v-col cols="12" class="mt-0 pt-0 pb-0">
              <v-text-field
                v-model="branch.code"
                label="お客様No."
                disabled
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mx-6 mb-1">
            <v-col cols="12" class="pl-0 mt-0 pt-0">
              <v-textarea
                v-model="branch.customerName"
                disabled
                label="塾名"
                rows="2"
                no-resize
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="mx-6 mb-1">
            <v-col cols="12" class="pl-0 mt-0 pt-0">
              <v-textarea
                v-model="branch.name"
                :counter="50"
                label="教室名"
                :disabled="isSampleAccount"
                :rules="rules.classroomName"
                rows="2"
                no-resize
              ></v-textarea>
            </v-col>
          </v-row>

          <fieldset>
            <legend>ログイン情報</legend>
            <v-row class="mx-6">
              <v-col cols="5">
                <v-text-field
                  v-model="branch.loginId"
                  :counter="30"
                  disabled
                  label="ログインID"
                  :rules="rules.loginId"
                ></v-text-field>
              </v-col>
            </v-row>
          </fieldset>

          <fieldset class="mt-10">
            <legend>契約情報</legend>
            <v-row class="mx-6">
              <v-col cols="5">
                <v-text-field
                  :value="branch.agreementUpdateOn | moment('YYYY年MM月DD日')"
                  label="前回契約更新日"
                  prepend-icon="mdi-calendar"
                  clearable
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="5" class="ml-4">
                <v-text-field
                  :value="branch.agreementEndOn | moment('YYYY年MM月DD日')"
                  label="契約満了日"
                  prepend-icon="mdi-calendar"
                  clearable
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </fieldset>

          <fieldset class="mt-10">
            <legend>詳細情報</legend>
            <v-row class="mx-6 mb-1">
              <v-col cols="12">
                <v-text-field
                  v-model="branch.tel"
                  label="教室電話番号"
                  :counter="11"
                  :disabled="isSampleAccount"
                  :rules="rules.tel"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6 mb-1">
              <v-col cols="12">
                <v-text-field
                  v-model="branch.representative"
                  label="教室担当者氏名"
                  :counter="20"
                  :rules="rules.classroomChargePerson"
                  :disabled="isSampleAccount"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6 mb-1">
              <v-col cols="12">
                <v-textarea
                  v-model="branch.email"
                  label="教室担当者メールアドレス"
                  :counter="100"
                  :rules="rules.mail"
                  :disabled="isSampleAccount"
                  rows="2"
                  no-resize
                ></v-textarea>
              </v-col>
            </v-row>
          </fieldset>
        </v-form>

        <v-row v-if="!isSampleAccount">
          <v-col class="ml-6 mt-5">
            <a target=”_blank” rel="noopener noreferrer" href="ゲットスルー2600システム利用の手引き.pdf">マニュアルはこちら</a>
          </v-col>
        </v-row>


        <v-btn class="mt-5 ml-6" color="secondary" v-if="!isSampleAccount" dark @click.stop="update">更新</v-btn>
        <router-link to="/teacher/home">
            <v-btn class="mt-5 ml-5" color="gray">TOPへ戻る</v-btn>
        </router-link>

        <!-- 解約 -->
        <v-btn
          class="float-right mt-6 ml-6"
          color="secondary"
          dark
          to="/teacher/cancel"
          v-if="!isSampleAccount"
        >
          解約はこちら
        </v-btn>


      </template>
    </v-base-card>
  </div>
</template>

<script>
import rules from '../../rules'
import VBaseCard from '@/components/molecules/BaseCard'
import moment from 'moment'

export default {
  components: {
    VBaseCard,
  },
  data () {
    return {
      branch: null,
      classroomValid: false,
      rules: rules,
    }
  },
  filters: {
    moment(date, format) {
        if (!date) return ''
        return moment(date).format(format)
    }
  },

  computed: {
    isSampleAccount() {
      return this.$store.getters['user/isSampleAccount']
    }
  },

  async mounted(){
    const res = await this.$axios.get(`/api/v1/teacher/branch/${this.$store.state.user.id}`)
    this.branch = res.data

    this.$gtag.pageview({
      page_path: '/setting',
      page_title: "ユーザー編集"
    })
  },

  methods: {
    async update() {
      this.classroomValid = this.$refs["classroom-form"].validate()
      if (!this.classroomValid) {
        this.$toasted.global.error({ message: '入力内容に不備があります。' })
        return
      }
      await this.$axios.put(`/api/v1/teacher/branch/${this.$store.state.user.id}`, this.branch)
      this.$store.commit('user/setClassroomName', { name: this.branch.name })
      this.$toasted.global.success({ message: '更新が完了しました' })
      this.$router.push('/teacher/home')
    },
  }
}
</script>

<style lang="stylus" scoped>
fieldset
  margin 5px 23px
  width 95%
  padding 2px 15px 15px 15px
  border 1px solid #c6c6c6
  border-radius 5px

.select
  font-size 11px !important

.school-name
  display inline-block
  width 200px

</style>
